import { useDispatch } from 'react-redux';
import { AppDispatch } from 'Store';

export const useDispatchApp = () => useDispatch<AppDispatch>();
